import axios from "axios";

export const getAnnouncementMsg = async () => {
  const { data = {} } = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/test/getAnnouncementMsg`
  );
  return data;
};